// src/utils/api.ts
import axios, {
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { store } from "../redux/store";
import {
  refreshTokensStart,
  refreshTokensSuccess,
  refreshTokensFailure,
  logout,
} from "../redux/userSlice";
import Cookies from "js-cookie";

export const Bot_URL = "http://103.12.1.132:8171/";
export const Chat = axios.create({
  baseURL: Bot_URL,
});

export const NodeApi_URL = "http://103.12.1.132:8186/api/";
export const Node = axios.create({
  baseURL: NodeApi_URL,
});

const api = axios.create({
  baseURL: "https://vtscombined.mssplonline.in",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

// Request queue for token refresh
let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value: unknown) => void;
  reject: (reason?: any) => void;
}> = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Request interceptor
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Get token from cookies
    const token = Cookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };

    // If 401 error and not a login/refresh request
    if (
      error.response?.status === 401 &&
      !originalRequest.url?.includes("/Auth/Login") &&
      !originalRequest.url?.includes("/Auth/RefreshLogin") &&
      !originalRequest._retry
    ) {
      // Queue request if already refreshing
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token: any) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const state = store.getState().user;
      const userName = state.userDetails?.userName;
      const refreshToken = Cookies.get("refresh_token");

      if (!userName || !refreshToken) {
        store.dispatch(logout());
        if (typeof window !== "undefined" && window.location.pathname !== "/") {
          window.location.href = "/";
        }
        return Promise.reject(error);
      }

      store.dispatch(refreshTokensStart());

      try {
        // Call refresh API
        const response = await axios.post(
          `${api.defaults.baseURL}/Auth/RefreshLogin`,
          {
            userName,
            refreshToken,
          }
        );

        if (response.data?.isSuccess) {
          const {
            token,
            refreshtoken,
            expiration,
            data: userData,
          } = response.data.data;

          store.dispatch(
            refreshTokensSuccess({
              token,
              refreshToken: refreshtoken,
              expiration,
              userDetails: userData,
            })
          );

          originalRequest.headers.Authorization = `Bearer ${token}`;

          processQueue(null, token);
          isRefreshing = false;

          return axios(originalRequest);
        } else {
          throw new Error(response.data?.mesg || "Token refresh failed");
        }
      } catch (refreshError: any) {
        store.dispatch(
          refreshTokensFailure(
            refreshError?.response?.data?.mesg ||
              refreshError?.message ||
              "Token refresh failed"
          )
        );
        store.dispatch(logout());

        processQueue(refreshError, null);
        isRefreshing = false;

        if (typeof window !== "undefined" && window.location.pathname !== "/") {
          window.location.href = "/";
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// API methods
export const authAPI = {
  login: async (userName: string, password: string) => {
    try {
      const response = await api.post("/Auth/Login", { userName, password });
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error;
    }
  },

  refreshToken: async (userName: string, refreshToken: string) => {
    try {
      const response = await api.post("/Auth/RefreshLogin", {
        userName,
        refreshToken,
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error;
    }
  },

  getMenu: async (userName: string) => {
    try {
      const token = Cookies.get("access_token");
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await api.get("/Adm/GetMenuUser", {
        params: { userName },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error;
    }
  },

  logout: async () => {
    // Add logout API call if available
    return { success: true };
  },
};

export default api;

// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// //export const HOST_URL = 'http://103.12.1.132:8166/api/';
// // export const HOST_URL = "https://vtsreactapi.mssplonline.com/api/";
// export const HOST_URL = "https://vtscombined.mssplonline.in/";

// export const HOST_URL2 = "https://vtscombined.mssplonline.in/";

// export const Bot_URL = "http://103.12.1.132:8171/";
// export const Chat = axios.create({
//   baseURL: Bot_URL,
// });

// //export const HOST_URL = 'https://localhost:44370/api/';

// export const NodeApi_URL = "http://103.12.1.132:8186/api/";
// export const Node = axios.create({
//   baseURL: NodeApi_URL,
// });

// const api = axios.create({
//   baseURL: HOST_URL,
// });

// export const apiNew = axios.create({
//   baseURL: HOST_URL2,
// });

// api.interceptors.request.use(
//   (config) => {
//     const tokenWithQuotes = sessionStorage.getItem("token");

//     const token = tokenWithQuotes?.replace(/^"(.*)"$/, "$1");

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       Logout();
//     }
//     return Promise.reject(error);
//   }
// );

// // const api2 = axios.create({
// //   baseURL: HOST_URL,
// // });

// // api2.interceptors.request.use(
// //   (config) => {
// //     const tokenWithQuotes = sessionStorage.getItem('token');

// // const token = tokenWithQuotes?.replace(/^"(.*)"$/, '$1');

// //     if (token) {
// //       config.headers.Authorization = `Bearer ${token}`;
// //     }
// //     return config;
// //   },
// //   (error) => {
// //     return Promise.reject(error);
// //   }
// // );

// // api2.interceptors.response.use(
// //   (response) => {
// //     return response;
// //   },
// //   (error) => {
// //     if (error.response && error.response.status === 401) {

// //       Logout();
// //     }
// //     return Promise.reject(error);
// //   }
// // );

// function Logout() {
//   localStorage.clear();
//   sessionStorage.clear();
//   toast.success("Token expired. Logging out...");
//   const navigate = useNavigate();
//   navigate("/");
// }

// export default api;
